import { Router } from '@angular/router';
import { User } from '../../core/models/user.model';
import { isProfileComplete } from './profile-photo.utils';

function isAdminRole(user: User): boolean {
  const role = user.role?.toUpperCase();
  return role === 'ADMIN' || role === 'SUPER-ADMIN' || role === 'SUPER ADMIN';
}

export function redirectBasedOnRole(router: Router, user: User | undefined): void {
  if (!user) {
    router.navigate(['/auth/login']);
    return;
  }

  const role = user.role?.toUpperCase();

  if (isAdminRole(user)) {
    router.navigate(['/admin/dashboard']);
    return;
  }

  if (role === 'NORMAL' || role === 'USER') {
    router.navigate(['/user/pets']);
    return;
  }

  router.navigate(['/auth/login']);
}

/** Sends the user to the first unfinished registration step, or into the app. */
export function redirectAfterAuth(router: Router, user: User | null | undefined): void {
  if (user && !user.emailConfirmed) {
    router.navigate(['/confirm-email']);
    return;
  }

  // Admin routes don't require a finished profile.
  if (user && !isAdminRole(user) && !isProfileComplete(user)) {
    router.navigate(['/register/photo']);
    return;
  }

  redirectBasedOnRole(router, user ?? undefined);
}
